export default "__VITE_ASSET__BlDjeW2s__"